import React from 'react';
import { Dialog, withStyles } from '@material-ui/core';
import GeoCodingComponent from './GeoCodingComponent';

const styles = (theme) => ({
  dialogContainer: {
    backgroundColor: theme.ModalBGColor,
    width: '85%',
    padding: 24,
    height: 600
  },
  root: {
    zIndex: 1401 // Ensures modal appears above dispatch route execution modal when opened from customer management (EditCustomerForm uses paperAnchorHighZIndex with zIndex 1401)
  }
});

const GeoCodingModal = ({ classes, customer, userData, close }) => {
  return (
    <Dialog
      disableBackdropClick
      open
      classes={{ paper: classes.dialogContainer, root: classes.root }}
      aria-labelledby="popup-title"
      maxWidth="lg">
      <GeoCodingComponent customer={customer} userData={userData} close={close} />
    </Dialog>
  );
};

export default withStyles(styles)(GeoCodingModal);
